export default __webpack_public_path__ + "65460fd835ad0dc9a433f48c6755d867.png";